import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import React from 'react';

export interface FormPartialProps {
    title?: string;
    isVisible?: boolean;
    children: React.ReactNode;
}

const FormPartial = ({ isVisible = true, ...props }: FormPartialProps) => {
    return (
        isVisible && (
            <>
                {props.title && (
                    <Divider className="form-divider" textAlign="left">
                        {props.title}
                    </Divider>
                )}
                <Box component="div" sx={{ paddingLeft: '10px' }}>
                    {props.children}
                </Box>
            </>
        )
    );
};

export default FormPartial;
